import React from 'react';
import {
  useLoungeAirportIata,
  useLoungeTerminal,
} from '@/hooks/loungesHooks/loungesHelperHooks';
import { useRouteParams } from '@/context/routeParamsContext';

const LoungeAirportandTerminal = () => {
  const { loungeId } = useRouteParams();
  const terminal = useLoungeTerminal(loungeId);
  const loungeAirport = useLoungeAirportIata(loungeId);

  return (
    <div className="tw-mb-4 tw-font-sans tw-text-20px tw-font-normal tw-text-gray-800 tw-font-features-off md_tw-mb-2 md_tw-text-2xl">
      <span className="tw-capitalize">{loungeAirport}</span> • {terminal}
    </div>
  );
};

export default LoungeAirportandTerminal;
